// eslint-disable-next-line import/prefer-default-export
export const confirmPasswordValidation = (password, confirm) => password === confirm;
